import React, { useEffect, useState, useMemo } from "react";
import Spinner from "../../common/Spinner";
import orderApiClient from "../OrdersApiClient";
import productsApiClient from "../../product-list-page/ProductsApiClient";
import { formatDateTimeShort } from "../../utils/formatDate";
import formatPrice from "../../utils/formatPrice";
import styles from "./MyOrders.module.scss";
const Limit = 20;
export function MyOrders(props) {
    var _a, _b, _c;
    const [orders, setOrders] = useState();
    const [page, setPage] = useState("");
    const [loading, setLoading] = useState(true);
    const [ordersProducts, setOrdersProducts] = useState({});
    const currentPage = useMemo(() => {
        if (!orders)
            return 1;
        return Math.floor((orders.position / Limit) + 1);
    }, [orders]);
    const totalPages = useMemo(() => {
        if (!orders)
            return 1;
        return Math.floor(orders.total / Limit) + 1;
    }, [orders]);
    const fetchOrders = async () => {
        setLoading(true);
        const orders = await orderApiClient.getOrders(Limit, page);
        const productsIds = orders.items
            .flatMap(x => x.orderItems)
            .map(x => x.productId);
        const products = await productsApiClient.getByIds(productsIds);
        const ordProds = {};
        orders.items.forEach(order => {
            ordProds[order.id] = [];
            order.orderItems.forEach(itm => {
                var _a;
                const prod = (_a = products.find(p => p.sku === itm.productName)) !== null && _a !== void 0 ? _a : products.find(p => p.rambaseId === itm.productId);
                ordProds[order.id].push({
                    name: (prod === null || prod === void 0 ? void 0 : prod.displayName) ? `${prod.sku} - ${prod.displayName}` : itm.productName,
                    quantity: itm.quantity,
                    url: (prod === null || prod === void 0 ? void 0 : prod.relativeUrl) ? `${props.storeUrl}${prod.relativeUrl}` : undefined,
                });
            });
        });
        setOrdersProducts(ordProds);
        setOrders(orders);
        setLoading(false);
    };
    useEffect(() => {
        void fetchOrders();
        window.scrollTo({ top: 0, left: 0 });
    }, [page]);
    return (React.createElement("section", { className: "my-orders-wrapper" },
        React.createElement("article", { className: "my-orders-items order-legend" },
            React.createElement("span", null, props.strings.order.orderedDate),
            React.createElement("span", null, props.strings.order.orderNumber),
            React.createElement("span", null, props.strings.order.goods),
            React.createElement("span", null, props.strings.order.statusLabel),
            React.createElement("span", null, props.strings.order.total)),
        loading && React.createElement("div", null,
            React.createElement("br", null),
            React.createElement(Spinner, { size: "small" })), orders === null || orders === void 0 ? void 0 :
        orders.items.map(item => {
            var _a;
            return React.createElement("article", { className: "my-orders-items", key: item.id },
                React.createElement("span", null,
                    React.createElement("span", { className: "mobile" }, props.strings.order.orderedDate),
                    formatDateTimeShort(item.createdAt)),
                React.createElement("span", null,
                    React.createElement("span", { className: "mobile" }, props.strings.order.orderNumber),
                    React.createElement("span", { className: "ordernumber" }, item.id)),
                React.createElement("div", null,
                    React.createElement("span", { className: "mobile" }, props.strings.order.goods), (_a = ordersProducts[item.id]) === null || _a === void 0 ? void 0 :
                    _a.map(product => React.createElement(React.Fragment, null,
                        !product.url &&
                            React.createElement("p", { key: product.name },
                                product.name,
                                " (",
                                product.quantity,
                                "\u00A0",
                                props.strings.order.unitPiece,
                                ")"),
                        product.url && React.createElement("a", { href: product.url, key: product.name },
                            product.name,
                            " (",
                            product.quantity,
                            "\u00A0",
                            props.strings.order.unitPiece,
                            ")")))),
                React.createElement("span", null,
                    React.createElement("span", { className: "mobile" }, props.strings.order.statusLabel),
                    props.strings.order.status[toCamelCase(item.status)]),
                React.createElement("span", null,
                    React.createElement("span", { className: "mobile" }, props.strings.order.total),
                    formatPrice(item.totalAmount)));
        }),
        orders && orders.items.length > 0 && React.createElement("div", { className: styles.pagesControlsContainer },
            React.createElement("a", { "data-disabled": !orders.firstPageHandle, className: styles.pageControlBtn, onClick: () => { var _a; return setPage((_a = orders.firstPageHandle) !== null && _a !== void 0 ? _a : ""); } }, (_a = props.strings.pagination) === null || _a === void 0 ? void 0 : _a.first),
            React.createElement("a", { "data-disabled": !orders.previousPageHandle, className: styles.pageControlBtn, onClick: () => { var _a; return setPage((_a = orders.previousPageHandle) !== null && _a !== void 0 ? _a : ""); } }, (_b = props.strings.pagination) === null || _b === void 0 ? void 0 : _b.previous),
            React.createElement("span", { className: styles.pageControlBtn },
                currentPage,
                "/",
                totalPages),
            React.createElement("a", { "data-disabled": !orders.nextPageHandle, className: styles.pageControlBtn, onClick: () => { var _a; return setPage((_a = orders.nextPageHandle) !== null && _a !== void 0 ? _a : ""); } }, (_c = props.strings.pagination) === null || _c === void 0 ? void 0 : _c.next))));
}
function toCamelCase(text) {
    return text[0].toLowerCase() + text.substring(1, text.length);
}
